import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/wastecontractor',
  component: () => import('@views/WasteContractor/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'wastecontractor.index',
      component: () => import('@/components/WasteContractor/WasteContractor')
    }
  ]
}
